import { Component, ViewChild, OnInit } from '@angular/core';
import Swal from 'sweetalert2'
import { SharedService } from '../services/shared.service';
import { PrescriptionReviewService } from '../services/prescription-review.service';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { startWith, map, debounceTime, distinctUntilChanged, switchMap, timeout } from 'rxjs/operators';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
const moment = _rollupMoment || _moment;

@Component({

  selector: 'app-prescription-review',
  templateUrl: './prescription-review.component.html',
  styleUrls: ['./prescription-review.component.css'],
})
export class PrescriptionReviewComponent implements OnInit {

  constructor(private sharedService: SharedService,
    private prescriptionReviewService: PrescriptionReviewService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService) { }
  facilities: any = [];
  residents: any = [];
  eprescribers: any = [];
  patientId: number;
  patientName: string;
  condition: boolean;
  prescriptionsReview: any[];
  prescriptionsReviewId: number = 0;
  showSuccessMessage: boolean = false;
  showErrorMessage: boolean = false;
  showLoadingMessage: boolean;
  errorMessage: string;
  statusId: any;
  /** Search list + Request PMR (shared range) */
  startDateDpForPMR: Date;
  endDateDpForPMR: Date;

  @ViewChild('closebutton', { static: false }) closebutton;

  ngOnInit(): void {
    this.sharedService.reloadUserPrivileges();
    this.spinnerService.show;
    this.patientId = 0;
    const monthStart = moment().startOf('month').startOf('day').toDate();
    const monthEnd = moment().endOf('month').startOf('day').toDate();
    this.startDateDpForPMR = monthStart;
    this.endDateDpForPMR = monthEnd;

    this.loadFacilities();
    if (this.sharedService.facilityId > 0) {
      this.loadFields();
    }
  }

  myControl = new FormControl();
  filteredOptions: Observable<any>;
  toHighlight: string = '';

  loadErrorMessage(message: any) {
    this.showErrorMessage = true;
    this.errorMessage = message.toString();
    window.scroll(0, 0);
    setTimeout(() => {
      this.showErrorMessage = false;
    }, 5000);
  }

  loadFilteredOptions() {

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(100),
      distinctUntilChanged(),
      switchMap(val => {
        return this._filter(val || '')
      })
    )
  }

  private _filter(value: string): Observable<any[]> {
    if (value == "") {
      this.patientId = 0;
      this.loadPrescriptions();
    }

    this.toHighlight = value;

    return this.getData()
      .pipe(
        map(response => response.filter(option => {
          return option.name.toLowerCase().indexOf(value.toLowerCase()) >= 0
        }))
      )

  }

  getPosts(value) {
    var resident = this.residents.find(f => f.name == value);
    this.patientId = resident.patientId;
    this.patientName = resident.name;
    this.onActionChangeResident();
  }

  getData() {
    return of(this.residents);
  }

  onActionChangeResident() {
    this.loadResidents();
    this.condition = false;
    this.loadPrescriptions();
  }

  onActionChangeStatus() {
    this.loadPrescriptions();
  }

  onActionFacilityUnit() {
    this.loadResidents();
    this.loadPrescriptions();
  }

  loadFacilities() {
    this.sharedService.getFacilitiesByPharmacyId().subscribe(data => { this.facilities = data; });
  }

  loadFields() {
    this.loadResidents();
    this.patientId = 0
    this.statusId = 1
    this.loadPrescriptions();
  }

  loadResidents() {
    this.sharedService.getResidentsByFacilityId()
      .subscribe(data => {
        this.residents = data;
      });
  }

  loadPrescriptions() {
    const validation = this.validatePmRDateRange();
    if (validation.length > 0) {
      return;
    }

    const startStr = moment(this.startDateDpForPMR).format('YYYY-MM-DD');
    const endStr = moment(this.endDateDpForPMR).format('YYYY-MM-DD');
    const statusIdNum = this.statusId != null ? parseInt(String(this.statusId), 10) : 0;
    const statusForApi = isNaN(statusIdNum) ? 0 : statusIdNum;

    this.prescriptionReviewService.GetPrescriptionReviewIndexVosByMonthRange(
      this.sharedService.pharmacyId,
      this.sharedService.facilityId,
      startStr,
      endStr,
      this.sharedService.getUserId(),
      statusForApi,
      this.sharedService.facilityUnitId,
      this.patientId
    ).subscribe(
      data => {
        this.prescriptionsReview = data;
        this.spinnerService.hide;
      },
      err => {
        this.spinnerService.hide;
        const msg = err && err.error != null
          ? (typeof err.error === 'string' ? err.error : (err.error.message || err.error.title || 'Unable to load PMR list.'))
          : 'Unable to load PMR list.';
        this.loadErrorMessage(msg);
      }
    );
  }

  openPrescriptionReview(id: any, patientId: any) {
    this.router.navigate(['prescription-review/review/' + patientId + '/' + id]);
  }

  setPrescriptionReviewId(id) {
    this.prescriptionsReviewId = id;
  }

  removePrescriptionReview() {
    this.prescriptionReviewService.deletePrescriptionReview(this.sharedService.getUserId(), this.prescriptionsReviewId).subscribe(result => {
      if (result.success) {
        this.showSuccessMessage = true;
        this.closebutton.nativeElement.click();
        this.loadPrescriptions();
        window.scroll(0, 0);
      } else {
        this.showErrorMessage = true;
        this.errorMessage = result.message;
      }
    });
  }

  openSyncPMR() {

    if (this.patientId === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No patient selected',
        text: 'Please select the patient you wish to sync PMR',
        confirmButtonText: 'OK'
      });
      return;
    }

    const syncDateErrors = this.validatePmRDateRange();
    if (syncDateErrors.length > 0) {
      this.loadErrorMessage(syncDateErrors.join(' '));
      return;
    }

    var pharmacyId = this.sharedService.pharmacyId;
    var facilityId = this.sharedService.facilityId;
    var patientId = this.patientId;
    var patientName = this.patientName;
    var startDate = moment(this.startDateDpForPMR).format("YYYY-MM-DD");
    var endDate = moment(this.endDateDpForPMR).format("YYYY-MM-DD");
    var startDateForDisplay = moment(this.startDateDpForPMR).format("MMM DD, YYYY")
    var endDateForDisplay = moment(this.endDateDpForPMR).format("MMM DD, YYYY")

    var syncMessageHtml = `<p>Patient: <strong>${patientName}</strong></p>`
    if (startDate == endDate) {
      syncMessageHtml += `<p>Date: <strong>${startDateForDisplay}</strong></p>`
    } else {
      syncMessageHtml += `<p>Start Date: <strong>${startDateForDisplay}</strong></p>`
      syncMessageHtml += `<p>End Date: <strong>${endDateForDisplay}</strong></p>`
    }

    var errorMessages = this.validationFromMonthAndToMonth(this.startDateDpForPMR, this.endDateDpForPMR)

    if (errorMessages.length > 0) {
      const errorsHtml = `
        <ul style="text-align: left; padding-left: 20px; margin: 0;">
          ${errorMessages.map(msg => `<li>${msg.trim()}</li>`).join('')}
        </ul>
      `;
      Swal.fire({
        icon: 'error',
        title: 'Error ',
        html: `
          <p>The month range for sync the PMR is incorrect</p>
          ${syncMessageHtml}
          <p>${errorsHtml}</p>
        `,
        confirmButtonText: 'OK'
      });
      return;
    }

    Swal.fire({
      icon: 'question',
      title: 'Sync PMR',
      html: `
        <p>Do you want to sync Patient Medication Review?</p>
        ${syncMessageHtml}
      `,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Yes, sync PMR',
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.showLoadingMessage = true;

      this.prescriptionReviewService.createPrescriptionReviewByPatientIdAndRange(pharmacyId, facilityId, patientId, startDate, endDate)
        .pipe(timeout(60000))
        .subscribe(
          data => {
            if (!data.success) {
              this.showLoadingMessage = false;
              this.loadErrorMessage("Oops! Something went wrong, please try again in a few minutes.");
              return;
            }

            this.showLoadingMessage = false;

            Swal.fire({
              icon: 'success',
              title: 'Sync PMR',
              html: `
                <p>The PMR has been successfully synchronized.</p>
                ${syncMessageHtml}
              `,
              confirmButtonText: 'OK'
            });
          },
          error => {
            this.showLoadingMessage = false;
            this.loadErrorMessage("Oops! Something went wrong, please try again in a few minutes.");
          });
    });
  }

  get enablePrint(): boolean {
    if (this.sharedService.userPrivilegeVo.hasPrescriptionReviewCreate === true) {
      return true;
    }
    return false;
  }

  endDateDpfilter = (d: Date | null): boolean => {
    const date = d || new Date();
    return date >= this.startDateDpForPMR;
  };

  validationFromMonthAndToMonth(fromMonth: Date, toMonth: Date) {
    const errors: string[] = [];

    // 1. null check
    if (!fromMonth || !toMonth) {
      errors.push('Both fromMonth and toMonth are required.');
      return errors;
    }

    // Only year/month are relevant → normalize to the first day of each month
    const from = new Date(fromMonth.getFullYear(), fromMonth.getMonth(), 1);
    const to = new Date(toMonth.getFullYear(), toMonth.getMonth(), 1);

    // 2. toMonth cannot be earlier than fromMonth
    if (to < from) {
      errors.push('To month cannot be earlier than from month.');
    }

    // 3. maximum gap is 12 months (inclusive)
    const monthDiff =
      (to.getFullYear() - from.getFullYear()) * 12 +
      (to.getMonth() - from.getMonth());

    // from == to          → diff = 0  → OK (1 month)
    // from = Jan, to = Jun → diff = 5 → OK (6 months)
    // from = Jan, to = Jul → diff = 6 → NG (7 months)
    if (monthDiff > 11) {
      errors.push('Range cannot be longer than 12 months.');
    }

    return errors;
  }

  private validatePmRDateRange(): string[] {
    const errors: string[] = [];
    if (!this.startDateDpForPMR || !this.endDateDpForPMR) {
      errors.push('Start and end dates are required.');
      return errors;
    }
    if (this.endDateDpForPMR < this.startDateDpForPMR) {
      errors.push('End date cannot be earlier than start date.');
    }
    return errors;
  }

  public onPmRDateChange() {
    this.showErrorMessage = false;
    const resultFieldsValidation = this.validatePmRDateRange();
    if (resultFieldsValidation.length === 0) {
      this.loadPrescriptions();
    } else {
      this.loadErrorMessage(resultFieldsValidation.join(' '));
    }
  }

  clearErrorMessage() {
    this.showErrorMessage = false;
    this.errorMessage = '';
  }
}
